"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class SeasonDependingContent {
    settings;
    elements = [];
    geoSeason = '';
    constructor(options = {}) {
        const defaultSettings = {
            className: 'season-depending',
            hiddenClassName: 'hidden',
            fallbackClassName: 'fallback',
            apiUrl: '/stage-ajax/geo-season/',
        };
        this.settings = Object.assign({}, defaultSettings, options);
        this.elements = Array.from(document.querySelectorAll('.' + this.settings.className));
        if (this.elements.length) {
            this.init();
        }
    }
    async init() {
        console.log('seasonDependingContent.init()');
        this.geoSeason = await this.getSeason();
        // Hide all elements at first
        this.elements.forEach(element => {
            element.classList.add(this.settings.hiddenClassName);
        });
        this.showSeasonContent(this.geoSeason);
    }
    getSeason() {
        const seasonFromStorage = sessionStorage.getItem('geo_season');
        if (typeof seasonFromStorage === 'string' && seasonFromStorage.length) {
            return Promise.resolve(seasonFromStorage);
        }
        // Fetch geo-ip season
        return fetch(this.settings.apiUrl)
            .then(response => response.json())
            .then(response => {
            if (response.season) {
                const season = response.season.toLowerCase();
                sessionStorage.setItem('geo_season', season);
                return season;
            }
            else {
                console.error('[season-depending-content] No season found', response);
                return '';
            }
        })
            .catch(error => {
            console.error('[season-depending-content] Error fetching season', error);
            return '';
        });
    }
    showElement(element) {
        element.classList.remove(this.settings.hiddenClassName);
        // Lagacy support: some old elements have inline display styles
        element.style.display = '';
    }
    showSeasonContent(visibleSeason) {
        if (visibleSeason) {
            this.elements
                .filter(element => element.classList.contains(visibleSeason))
                .forEach(visibleElement => {
                this.showElement(visibleElement);
            });
            // For some season-depending links there is an added class "fallback".
            // If chosen geo-ip-season's link is not available (for example "Van tyres" do not have 'all season' tires @ en_US)
            // then the whole link disappears. We cannot have that.
            // .fallback class to the rescue!
            // This loops through .season-depending.fallback links and checks if the do not have any visible siblings.
            // If not, then it shows the .fallback link (e.g. /tires/van-tires/winter-tires/)
            this.elements
                .filter(element => element.classList.contains(this.settings.fallbackClassName))
                .forEach(fallbackElement => {
                const visibleSiblings = Array.from(fallbackElement.parentElement?.children || []).filter(child => {
                    // Filter out self
                    if (child === fallbackElement) {
                        return false;
                    }
                    //.season-depending:not('.hidden')
                    if (child.classList.contains(this.settings.className) && !child.classList.contains(this.settings.hiddenClassName)) {
                        return true;
                    }
                    return false;
                });
                if (visibleSiblings.length === 0) {
                    this.showElement(fallbackElement);
                    fallbackElement.classList.add(`${this.settings.fallbackClassName}-active`);
                }
            });
        }
    }
}
exports.default = SeasonDependingContent;
